<div class="bg" ><div class="wrapper">
  <div class="home" routerLink="/">
    <img src="../../../../assets/images/studenty.png" routerLink="/"/><span  style="color: #ffff;">Back to home</span> 
  </div>
  <div class="headline"  >
    <h1 >Login</h1>
  </div>
  <form name="user" #u="ngForm" (ngSubmit)="signIn()">
    <div style="color:#ffff;padding-bottom: 10px;padding-left: 15px;">Email</div>
    <div class="signup">
      <div class="form-group">
        <input type="email" class="form-control" placeholder="Your mail" #email="ngModel" name="email" ngModel [(ngModel)]="user.email" required/>
        <div class="alert alert-danger" *ngIf="email.invalid && email.touched" style="text-align: center; width: 500px; margin-left: 80px">
          Email is a Required Field !
        </div>
      </div>
      <div style="color:#ffff;padding-bottom: 10px;padding-left: 15px;">Password</div>
      <div class="form-group">
        <input  matInput [type]="hide ? 'password' : 'text'" class="form-control" placeholder="Password" #mdp="ngModel" name="mdp" ngModel [(ngModel)]="user.mdp" required />
        <fa-icon [icon]="faEye" style="display: flex;float: right; transform: translateY(-230%);margin-right: 2%;cursor: pointer; color: #79D1EF; font-size: x-large;" class="material-icons" matSuffix (click)="hide = !hide" >{{ hide ? "Show" : "Hide" }}></fa-icon>
        <div class="alert alert-danger" *ngIf="mdp.invalid && mdp.touched" style="text-align: center; width: 500px; margin-left: 80px">
          Password is a Required Field !
        </div>
      </div>
      <div>
        <input type="checkbox" id="checkbox" [(ngModel)]="user.rememberMe" name="rememberMe" />
        <label for="checkbox" style="margin-top: 0px;color:#ffff"> &nbsp;Remind me 
      </label>
      </div>
      <div class="forget-password">

        <div class="check-box">
          
          <input type="checkbox" id="checkbox" #regle="ngModel" name="regle" ngModel required />
          <label for="checkbox" style="margin-top: 0px;color:#ffff"> &nbsp;I accept
            <a href="/home/login/confidentialite" style="color: #79D1EF"> the privacy rules</a>
          </label>
         
          
        </div>
        <div class="check-box">
         
        </div>
        <a href="/home/login/forgotpassword" style="color:white;">Forget password?</a>
      </div>
      <div style="display: flex;gap: 1rem;">
        <button [disabled]="u.invalid" class="btn" >LOGIN</button>

      </div>
 
      <div [hidden]="hideMsg" class="alert alert-danger" style="width: 500px; margin-left: 80px; text-align: center; border-radius: 15px;">
        {{ msg }}
      </div>
      <div class="account-exist">
        Create an account ?<a href="home/Register "style="color: #79D1EF;">Click Here</a>
      </div>
      <div class="account-exist"></div>
    </div>
  </form>
</div>
</div>